module.exports = __webpack_public_path__ + "img/cover.c7d39062.webp";